//LL: 21.01.19  ChartElementsFormatSelect

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { FormatChooser, formatIsCustomizable, IFormatChooserValue } from '../../../../_common/platform/tsx/FormatChooser';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

import * as Utils from '../../../../_common/platform/ts/Utilities';
import { IGlob } from '../../../../_common/application/ts/Glob';
import { ATTRIBUTE_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');

declare var require;

export const ChartElementsFormatKeys = {
    everywhere: 'everywhere',
    inTooltip: 'inTooltip',
    inPointLabels: 'inPointLabels',
    inLegend: 'inLegend',
    argLabel: 'argLabel'
};

//  either "axis" or "axisExclude"
var elementList = {
    everywhere: {
        val: ChartElementsFormatKeys.everywhere,
        text: 'Default',
        axisExclude: []
    },
    //inTooltip: {val: ChartElementsFormatKeys.inTooltip, text: "In ToolTips", axisExclude: ["XL", "C2F"] },
    inTooltip: {
        val: ChartElementsFormatKeys.inTooltip,
        text: 'In ToolTips',
        axisExclude: []
    },
    inPointLabels: {
        val: ChartElementsFormatKeys.inPointLabels,
        text: 'In Point Labels',
        axisExclude: ['XL', 'XC', 'C2F', 'T', 'A']
    },
    inLegend: {
        val: ChartElementsFormatKeys.inLegend,
        text: 'In Legend',
        axis: ['X2', 'X3', 'X5'],
        axisPie: ['X1']
    },
    argLabel: {
        val: ChartElementsFormatKeys.argLabel,
        text: 'Argument Labels',
        axis: ['XL']
    }
    //LL: argLabels are not used in Tooltips and PointLabels, only on X axis:
};

class ChartElementsFormatRow extends React.Component<
    {
        dataSourceID?: number;
        themeObj?: any;

        value?: any;
        element?: any;
        type?: string;
        timePart?: string;
        aggregateGroup?: string;

        index?: number;
        key?: string;

        popupPriority?: number;

        onChange?(value, key, index);
        onRemove?(index);

        glob;
    },
    any
> {
    constructor(props) {
        super(props);
    }

    getValueCopy() {
        return _.clone(this.props.value || {});
    }

    normalize(value) {
        let type = this.props.type || value.attrType;

        switch (type) {
            case 's':
                delete value.formatFront;
                delete value.precision;
                delete value.useDigitGrouping;
                delete value.overwriteInheritedUseDigitGrouping;
                delete value.formatZeroAsBlank;
                delete value.overwriteInheritedFormatZeroAsBlank;
                break;

            case 'i':
                break;

            case 'r':
                break;

            case 'e':
                delete value.formatFront;
                delete value.precision;
                delete value.useDigitGrouping;
                delete value.overwriteInheritedUseDigitGrouping;
                delete value.formatZeroAsBlank;
                delete value.overwriteInheritedFormatZeroAsBlank;
                break;

            case 'b':
                delete value.precision;
                delete value.useDigitGrouping;
                delete value.overwriteInheritedUseDigitGrouping;
                break;

            case 'none':
                delete value.formatFront;
                delete value.precision;
                delete value.useDigitGrouping;
                delete value.overwriteInheritedUseDigitGrouping;
                delete value.formatZeroAsBlank;
                delete value.overwriteInheritedFormatZeroAsBlank;
                break;
        }

        //LL:  null means 'default', but don't set  -> remove such value
        //if (value.formatFront == null) {
        //    value.formatFront = 'default';
        //}
    }

    handleFormatChange = (value: IFormatChooserValue) => {
        const obj = this.getValueCopy();

        if (value.formatFront == null) {
            delete obj.formatFront;
        } else {
            obj.formatFront = value.formatFront;
            obj.customFormat = value.customFormat;
        }

        obj.precision = value.precision;
        obj.useDigitGrouping = value.useDigitGrouping;
        obj.overwriteInheritedUseDigitGrouping = value.overwriteInheritedUseDigitGrouping;
        obj.formatZeroAsBlank = value.formatZeroAsBlank;
        obj.overwriteInheritedFormatZeroAsBlank = value.overwriteInheritedFormatZeroAsBlank;
        obj.useFiscalPrefix = value.useFiscalPrefix;
        obj.fiscalYearDivider = value.fiscalYearDivider;
        obj.currency = value.currency;

        this.processValueChange(obj);
    };

    processValueChange(value) {
        this.normalize(value);

        //LL: do nothing, remove in caller: ChartElementsFormats.handleChangeRow
        //LL:  null means 'default', but don't set  -> remove such value
        if (value.formatFront == null) {
            //value.formatFront = 'default';
        }

        // handleChangeRow = (obj, elemVal, index: number) => {}
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.element.val, this.props.index);
        }
    }

    getElement(element) {
        return (
            <span key={'object_' + element.val} className="form-control">
                {element.text}
            </span>
        );
    }

    //   value is formatObj
    getFormat(value) {
        let type = this.props.type;
        let timePart = this.props.timePart;

        if (timePart === 'none') {
            timePart = null;
        }

        let customizeFormat = true;

        if (this.props.aggregateGroup === 'count') {
            customizeFormat = true;
            type = ATTRIBUTE_TYPES.INTEGER;
        } else {
            customizeFormat = formatIsCustomizable(type);
        }

        if (!customizeFormat) {
            return;
        }

        let attrType = type;

        if (timePart != null) {
            type = ATTRIBUTE_TYPES.INTEGER;
        }

        //LL: they differ: when TimePart type = i, attrType = datetime
        value.type = type; //VR for FormatChooser +  <isNoValue = { true }>
        value.attrType = attrType; //type;  // for FormatChooser
        value.timePart = timePart;

        return (
            <FormatChooser
                isScalar={true}
                value={value}
                dataSourceID={this.props.dataSourceID}
                customizeFormat={customizeFormat}
                showStyle={false}
                showTemplate={false}
                showRawTemplate={false}
                theme={this.props.themeObj}
                glob={this.props.glob}
                onChange={this.handleFormatChange}
            />
        );
    }

    render() {
        const value = this.props.value || {};

        //element={ elem }
        //value={ this.props.value[elem.val] }

        return (
            <tr className={'attribute-row'}>
                <td className="cell-object">{this.getElement(this.props.element)}</td>
                <td className="cell-formatFront">{this.getFormat(value)}</td>
            </tr>
        );
    }
}

class ChartElementsFormats extends React.Component<any, any> {
    constructor(props) {
        super(props);

        // popupPriority?: number;

        //this.state = {
        //};
    }

    componentDidMount() {}
    componentWillUnmount() {}

    processValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    handleChangeRow = (formatObj, elemKey, index: number) => {
        let value = $.extend(true, {}, this.props.value);

        //LL:  null means 'default', remove such value
        if (
            formatObj.formatFront == null &&
            formatObj.formatZeroAsBlank !== true &&
            formatObj.overwriteInheritedFormatZeroAsBlank !== true &&
            formatObj.overwriteInheritedUseDigitGrouping !== true &&
            formatObj.useDigitGrouping !== true
        ) {
            delete value[elemKey];
        } else {
            value[elemKey] = formatObj;
        }

        this.processValueChange(value);
    };

    render() {
        let isPie = this.props.chartType == 'pie' || this.props.chartType == 'doughnut';

        let elemList = [];
        _.each(elementList, (elem: any, key) => {
            let fnd = false;
            if (elem.axis != null || elem.axisPie != null) {
                if (isPie) {
                    if (_.indexOf(elem.axisPie, this.props.axis) >= 0) {
                        fnd = true;
                    }
                } else {
                    if (_.indexOf(elem.axis, this.props.axis) >= 0) {
                        fnd = true;
                    }
                }
            } else if (elem.axisExclude != null) {
                if (_.indexOf(elem.axisExclude, this.props.axis) < 0) {
                    fnd = true;
                }
            }
            if (fnd) {
                elemList.push(_.clone(elem));
            }
        });

        //LL:  this.props.value:
        //  {  inTooltip: formatObj, inPointLabels formatObj, ... }

        let rows = _.map(elemList, (elem: any, index) => {
            return (
                <ChartElementsFormatRow
                    key={index + '-' + elem.val}
                    index={index}
                    element={elem}
                    value={this.props.value[elem.val]}
                    type={this.props.type}
                    timePart={this.props.timePart}
                    aggregateGroup={this.props.aggregateGroup}
                    dataSourceID={this.props.dataSourceID}
                    popupPriority={this.props.popupPriority}
                    onChange={this.handleChangeRow}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                />
            );
        });

        let timePartStr = '';
        if (this.props.timePart != null) {
            timePartStr = ', timePart = ' + this.props.timePart;
        }

        let aggregateStr = '';
        if (this.props.aggregateGroup != null && this.props.aggregateGroup !== 'group') {
            aggregateStr = ', aggregate = ' + this.props.aggregateGroup;
        }

        return (
            <div className={'formats-config-container'}>
                <label>
                    {'Attribute type: ' + Utils.explainAttributeType(this.props.type) + aggregateStr + timePartStr}
                </label>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="cell-object">Element to format</th>
                            <th className="cell-formatFront textAlignLeft">Format</th>
                        </tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        );
    }
}

interface IChartElementsFormatSelectPopupOptions extends IPopupOptions {
    value;
    type: string;
    timePart?: string;
    axis: string;
    aggregateGroup: string;
    chartType: string;
    dataSourceID?: number;
    themeObj?;

    popupPriority?: number;
    onChange(value): void;
}

export class ChartElementsFormatSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IChartElementsFormatSelectPopupOptions;
        close(): void;
        glob: IGlob;
    },
    {
        value;
        hasIntervalError;
        height?: number;
        width?: number;
    }
> {
    private references: {
        popoverContent?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        const valueOrig = $.extend(true, {}, this.props.options.value);

        this.state = {
            value: valueOrig, //this.props.options.value
            hasIntervalError: false,
            height: 500, //LL: as in FormatChooser  ??? can change, depends on current Tab  Reset in DidMount
            width: 530 //LL: as in FormatChooser   sass - 520      Reset in DidMount
        };
    }

    private globalClickIndex = 0;

    componentDidMount() {
        if (this.props.options.popupPriority != null) {
            this.globalClickIndex = reactGlobalClick.register(this.props.close, this.props.options.popupPriority);
        } else {
            this.globalClickIndex = reactGlobalClick.register(this.props.close);
        }

        const dialog = this.references.popoverContent as HTMLElement;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    componentWillUnmount() {
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    handleChange = (value, hasIntervalError?) => {
        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });

        if (typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(value);
        }
    };

    containerClick = (e) => {
        //reactGlobalClick.trigger(e);
        //reactGlobalClick.cancel();
        if (this.props.options.popupPriority != null) {
            reactGlobalClick.trigger(e, this.props.options.popupPriority + 1);
            reactGlobalClick.cancel();
        }

        //LL: commented.  See PalettesField
        //   It was forbidding proper closing of previous popup when "click-on-color" (reactGlobalClick.trigger was not called)
        //e.stopPropagation();
        //e.preventDefault();
    };

    closeButtonHandler = () => {
        let hasError = this.state.hasIntervalError;
        //if (hasError != true) {
        //    let errors = validateWhole(this.state.value);
        //    if (errors.length > 0) {
        //        hasError = true;
        //    }
        //}

        if (hasError) {
            this.props.glob.AppActions.showNotification_Warning(
                'Configuration is not valid. Some fields have wrong value'
            );
        } else {
            if (typeof this.props.options.onChange === 'function') {
                this.props.options.onChange(this.state.value);
            }
            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        this.props.close();
    };

    render() {
        const popoverStyle = Utils.getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });

        let style: any = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: this.props.zIndex
        };

        let popupTitle = 'Formats of Chart Elements';

        let content = (
            <div className="popover-body">
                <ChartElementsFormats
                    value={this.state.value}
                    type={this.props.options.type}
                    timePart={this.props.options.timePart}
                    axis={this.props.options.axis}
                    aggregateGroup={this.props.options.aggregateGroup}
                    chartType={this.props.options.chartType}
                    dataSourceID={this.props.options.dataSourceID}
                    themeObj={this.props.options.themeObj}
                    popupPriority={this.props.options.popupPriority}
                    onChange={this.handleChange}
                    glob={this.props.glob}
                />
            </div>
        );

        return (
            <div className="chart-elements-format-select">
                <div
                    className={'popover chart-elements-format-select-popover ' + popoverStyle.side}
                    style={style}
                    onClick={this.containerClick}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }} //LL: 28.01.25
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>

                    {content}

                    <div className="modal-footer">
                        <button className="btn btn-success" onClick={this.closeButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

export class ChartElementsFormatSelect extends React.Component<
    {
        value;
        type: string;
        timePart?: string;
        axis: string;
        aggregateGroup: string;
        chartType: string;

        onChange(value);

        dataSourceID?: number;
        themeObj?;
        glob: IGlob;
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    //private globalClickIndex = 0;  //LL:  not here, in popups
    private popupPriority = 2; //LL: use in reactGlobalClick to close previous popup dialog

    componentDidMount() {}
    componentWillUnmount() {}

    handleChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    processSelectorShow = (e) => {
        const offset = $(e.target).offset();

        this.props.glob.DialogActions.createPopup<IChartElementsFormatSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value,
            type: this.props.type,
            timePart: this.props.timePart,
            axis: this.props.axis,
            aggregateGroup: this.props.aggregateGroup,
            chartType: this.props.chartType,
            dataSourceID: this.props.dataSourceID,
            themeObj: this.props.themeObj,

            popupPriority: this.popupPriority, 
            onChange: this.handleChange,
            component: ChartElementsFormatSelectPopup
        });
    };

    processContainerClick = (e) => {
        //LL: commented.
        //   It was forbidding proper closing of previous popup when "click-on-cog" (reactGlobalClick.trigger was not called)
        //e.stopPropagation();
        //e.preventDefault();
    };

    render() {
        let value = null;
        let title = '';

        if (this.props.value == null) {
            value = <em className="empty" onClick={this.processSelectorShow}></em>;
        } else {
            value = ''; //LL: here value is interpreted as string

            //LL: Leo does not want this indication
            let cnt = 0;
            _.each(this.props.value, function (v: any, key) {
                if (cnt > 0) {
                    title += ', ';
                }
                title += elementList[key].text;
                cnt++;
            });

            if (cnt > 0) {
                value = (
                    <span
                        className="glyphicon glyphicon-equalizer"
                        title={title}
                        style={{ cursor: 'pointer' }}
                        onClick={this.processSelectorShow}
                    ></span>
                );
            }
        }

        return (
            <div className="formats-select" onClick={this.processContainerClick}>
                <div className="content">
                    <span
                        className="glyphicon glyphicon-cog"
                        title={title}
                        style={{ cursor: 'pointer' }}
                        onClick={this.processSelectorShow}
                    ></span>

                    <span className="value" title={title}>
                        {value}
                    </span>
                </div>
            </div>
        );
    }
}
